import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import LoadingSVG from './LoadingSVG';

function LoadingIndicator() {
  const reduxStore = useSelector(state => state, shallowEqual);
  const { requests } = reduxStore;
  const { pending } = requests;

  if (!Object.keys(pending).length) {
    return null;
  }

  return (
    <div id="loadingInfo" className="load">
      <figure className="loading">
        <LoadingSVG />
        <figcaption>
          ...
        </figcaption>
      </figure>
    </div>
  );
}

export default LoadingIndicator;
